module.exports = __webpack_public_path__ + "img/winter-toons.1bcac649.jpg";